export { makeStyles, theme as baseTheme, AnyColor, lighten } from '@guiker/components-core'
export { clsx } from '@guiker/clsx'
import { theme as baseTheme } from '@guiker/components-core'

const theme = {
  ...baseTheme,
}

export { theme }
